import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import {
  SET_ON_CANCEL,
  SET_ON_CONTINUE,
  SET_SUCCESS,
} from '../../reducers/actionReducer';
import uploadFileSuccess from '../../assets/winners-animate.svg';
import { FILES_QUERY } from '../../queries';

export default function UploadFileSuccess({ dispatchAction }) {
  const client = useApolloClient();

  useEffect(() => {
    async function handleDone() {
      setTimeout(
        async () =>
          await client.refetchQueries({
            include: [FILES_QUERY],
          }),
        2000
      );

      dispatchAction({
        type: SET_SUCCESS,
        payload: {
          message: null,
        },
      });
    }

    if (dispatchAction) {
      dispatchAction({
        type: SET_ON_CONTINUE,
        payload: {
          onContinue: handleDone,
        },
      });
      dispatchAction({
        type: SET_ON_CANCEL,
        payload: {
          onCancel: handleDone,
        },
      });
    }
  }, [dispatchAction, client]);

  return (
    <div className="w-full h-full">
      <div className="flex flex-col justify-center items-center w-full">
        <div className="flex items-center mb-6 lg:mb-12 lg:mt-6 justify-center">
          <img
            className="w-3/5 2xl:w-3/4"
            src={uploadFileSuccess}
            alt="person with broom"
          />
        </div>
        <div className="flex flex-col space-y-5 px-16 xl:px-24 mb-6 mt-6">
          <p>
            We want to make your data sparkling clean! As our gift to you, we're
            busy applying hygiene techniques to make sure every record is fresh
            and up to date. Yay for clean data!{' '}
          </p>
          <p>
            Once your file is done processing (hint hint, see the status bar
            below), you'll be ready to create the best audience possible.
          </p>
          <p>
            We'll make sure to drop you an email as soon as the file is ready as
            well so you can start using as to include and exclude your way to
            the best audience ever.
          </p>
        </div>
      </div>
    </div>
  );
}
